import { Column } from '../component/Column/types';

export function findColumnIndexById(columns: Column[], id: string) {
  return columns.findIndex((obj) => obj.id === id);
}
